import { ExternalLink } from "lucide-react";

/**
 * Authority strip: one line of verifiable credentials directly under the hero
 * CTAs, where a visitor decides whether to trust the tool. It replaces the
 * "Authored by" grid further down the page, which said the same things at
 * six times the height.
 *
 * Facts are verbatim from tonyaevans.com/about. Do not edit without
 * cross-checking the source page.
 */
const FACTS = [
  "Built by Dr. Tonya M. Evans, Esq.",
  "Congressional testimony, House Financial Services Subcommittee on Digital Assets (2023)",
  "External Expert Reviewer, Central Bank of Nigeria VASP Regulations (2025)",
  "Independent Board Member, Digital Currency Group",
  "Author, Digital Money Demystified",
];

export const AuthorityStrip = () => (
  <section
    data-testid="authority-strip"
    aria-label="Credentials"
    className="border-b border-ink bg-paper"
  >
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-4">
      <p className="font-mono text-[11px] sm:text-xs leading-relaxed text-ink/80">
        {FACTS.map((fact, i) => (
          <span key={fact}>
            {i > 0 && <span className="text-ink/35 mx-1.5">&middot;</span>}
            {i === 0 ? <strong className="text-ink font-semibold">{fact}</strong> : fact}
          </span>
        ))}
        <span className="text-ink/35 mx-1.5">&middot;</span>
        <a
          href="https://tonyaevans.com/about"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="authority-strip-bio"
          className="text-blueprint underline underline-offset-2 hover:text-ink transition-colors inline-flex items-center gap-1"
        >
          Read full bio <ExternalLink size={10} strokeWidth={1.75} />
        </a>
      </p>
    </div>
  </section>
);

export default AuthorityStrip;
